import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';

export interface IVHSMegaTilesItems {
	/**
	 * Link
	 */
	link?: ILink;
	/**
	 * Icon
	 */
	icon?: 'call' | 'email' | 'purchases' | 'course';
	/**
	 * Text
	 */
	text?: string;
	/**
	 * Footnote
	 */
	footnote?: string;
}
export interface IVHSMegaTilesProps extends IBaseElementProps {
	/**
	 * Items
	 */
	items?: IVHSMegaTilesItems[];
}

/**
 * Mega Tiles
 * @block
 * @icon images-alt
 */
const VHSMegaTiles: React.FC<IVHSMegaTilesProps> = ({
	items = [],
	className,
	classNames = [],
}) => {
	return (
		<ul className={className || cn('vhs-mega-tiles', ...classNames)}>
			{items && items?.length > 0 && items.map(({ link, icon, text, footnote }, index) => {
				if (index < 2) {
					return (
						<li className="vhs-mega-tiles__item" key={index}>
							<a href={link?.href} className="vhs-mega-tiles__link">
								{icon && <i className={`vhs-mega-tiles__icon icon icon-${icon}`} />}
								<div className="vhs-mega-tiles__content">
									{link?.label && <span className="vhs-mega-tiles__heading">{link?.label}</span>}
									{text && <p className="vhs-mega-tiles__text">{text}</p>}
									{footnote && <p className="vhs-mega-tiles__footnote">{footnote}</p>}
								</div>
							</a>
						</li>
					)}
				}
			)}
		</ul>
	);
};

export default VHSMegaTiles;
